import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authStore } from '../api/client';

/**
 * UnauthorizedPage
 *
 * Shown when an authenticated user tries to visit a route their role is
 * not allowed to access.
 */
export default function UnauthorizedPage() {
  const navigate = useNavigate();

  const goHome = () => {
    if (!authStore.isAuthenticated) {
      navigate('/login', { replace: true });
    } else if (authStore.role === 'CANDIDATE') {
      navigate('/candidate', { replace: true });
    } else {
      navigate('/dashboard', { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-shell flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md glass-dark rounded-3xl shadow-strong p-8 text-center">
        <span className="text-4xl block mb-3" aria-hidden="true">⛔</span>
        <h1 className="text-xl font-bold text-white mb-2">Access denied</h1>
        <p className="text-sm text-slate-300 mb-6">
          Your account doesn't have permission to view this page.
        </p>
        <button
          type="button"
          onClick={goHome}
          className="btn btn-primary btn-md w-full"
        >
          Go to my dashboard
        </button>
        <div className="mt-4">
          <Link to="/login" className="text-xs text-slate-300 hover:text-white">
            Sign in as a different user
          </Link>
        </div>
      </div>
    </div>
  );
}
